<template>
  <v-chart :option="option" autoresize
           @legendselectchanged="onLegendSelectChanged"
  />
</template>

<script>
import {use} from 'echarts/core';
import {CanvasRenderer} from 'echarts/renderers';
import {PieChart} from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GraphicComponent
} from 'echarts/components';
import VChart from 'vue-echarts';
import {ref, computed, defineComponent} from 'vue';
import i18n from "../../lang/i18n";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GraphicComponent
]);

export default defineComponent({
  components: {
    VChart,
  },
  props: ["chartData", "locale"],
  provide: {},
  setup(props) {

    const selectedLegend = ref({});

    const option = computed(() => {
      let locale = props.locale
      let chartData = props.chartData

      let data = chartData.data.map((v, i) => {
        return {value: v, name: locale === "en" ? chartData.en[i] : chartData.vi[i]}
      })
      let total = data.reduce((sum, item) => selectedLegend.value[item.name] !== false ? sum + item.value : sum, 0);
      let totalFormatter = `{a| ${i18n.t('ui.total')}}\n {b| ${total}}`

      return {
        color: chartData.colors,
        tooltip: {
          trigger: 'item',
          padding: 0,
          formatter: function (params) {
            return `
              <p style="padding: 8px; margin: 0px;">${params.marker} ${params.data.name}</p>
              <hr style="margin: 0px;"></hr>
              <p style="font-size: 24px; padding: 20px 10px; margin: 0px;"><b>${params.data.value} (${Math.round(params.percent)}%)</b></p>
             `
          }
        },
        legend: {
          bottom: "3%",
          orient: 'vertical',
          left: 'center',
          icon: 'circle',
          textStyle: {
            fontFamily: 'roboto',
            fontSize: 16,
          },
          // Sắp xếp legend theo alphabet của tên hiển thị (tuỳ theo locale)
          data: data
            .map(d => d.name)
            .sort((a, b) => a.localeCompare(b, locale === 'en' ? 'en' : 'vi', { sensitivity: 'base' })),
          selected: selectedLegend.value  // Sử dụng trạng thái legend hiện tại
        },
        series: [
          {
            // name: 'Báo động đỏ',
            type: 'pie',
            radius: ['72%', '90%'],
            center: ['50%', '40%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 6,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              fontSize: 20,
              fontFamily: 'roboto',
              position: 'center',
              formatter: totalFormatter,
              rich: {
                a: {
                  fontFamily: 'roboto',
                  fontSize: 18,
                  lineHeight: 30
                },
                b: {
                  fontFamily: 'roboto',
                  fontStyle: 'bold',
                  fontSize: 32,
                  lineHeight: 60
                },
              },
            },

            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: 40,
            //     fontWeight: 'bold'
            //   }
            // },
            // labelLine: {
            //   show: false
            // },
            data: data
          }
        ],
      }
    });

    const onLegendSelectChanged = (params) => {
      selectedLegend.value = params.selected;
    };

    return {option, onLegendSelectChanged};
  },
});


</script>

<style scoped>
</style>


